import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PaymentElement } from "@stripe/react-stripe-js";
import { CardContainer } from "./CardContainer";
import { CardTitle } from "./CardTitle";

export const PaymentMethodCard: FC = () => {
  const { t } = useTranslation();

  return (
    <CardContainer gap={6}>
      <CardTitle>{t("planPayment.formTitle")}</CardTitle>
      <PaymentElement />
    </CardContainer>
  );
};
